import {
  DEFAULT_DASHBOARD_PATH,
  canAccessWorkspaceRoute,
  getActiveWorkspaceCapabilities,
  getWorkspaceLandingPath,
} from "./workspaceAuthorization";

const LOCAL_REDIRECT_ORIGIN = "https://haastia.local";
const AUTH_PAGE_PATH_PATTERN = /^\/(login|signin|signup)(\/|$)/i;

const ROLE_HOME_PATHS = Object.freeze({
  admin: "/admin",
  professional: DEFAULT_DASHBOARD_PATH,
  provider: DEFAULT_DASHBOARD_PATH,
  recruiter: "/recruiter",
  customer: "/",
});

const normalizePath = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

export const isAuthPagePath = (value) => {
  const normalized = normalizePath(value);
  if (!normalized.startsWith("/")) return false;
  const pathname = normalized.split("?")[0].split("#")[0];
  return AUTH_PAGE_PATH_PATTERN.test(pathname);
};

export const sanitizeNextPath = (nextPath) => {
  const trimmed = normalizePath(nextPath);
  if (!trimmed || !trimmed.startsWith("/")) {
    return null;
  }
  if (trimmed.startsWith("//")) {
    return null;
  }
  if (/^\/https?:/i.test(trimmed) || /:\/\//.test(trimmed)) {
    return null;
  }

  try {
    const parsed = new URL(trimmed, LOCAL_REDIRECT_ORIGIN);
    if (parsed.origin !== LOCAL_REDIRECT_ORIGIN) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (err) {
    return null;
  }
};

export const getRoleHomePath = (role, platformRole) => {
  if (platformRole === "platform_admin") return ROLE_HOME_PATHS.admin;
  const normalizedRole = typeof role === "string" ? role.trim().toLowerCase() : "";
  return ROLE_HOME_PATHS[normalizedRole] || ROLE_HOME_PATHS.customer;
};

export const getPostAuthRedirectPath = ({ role, platformRole, nextPath, user = null } = {}) => {
  const safeNextPath = sanitizeNextPath(nextPath);
  const workspaceCapabilities = getActiveWorkspaceCapabilities(user);
  const hasWorkspace = workspaceCapabilities?.isWorkspaceMember === true;
  if (
    safeNextPath &&
    !isAuthPagePath(safeNextPath) &&
    (!hasWorkspace || canAccessWorkspaceRoute({ path: safeNextPath, capabilities: workspaceCapabilities }))
  ) {
    return safeNextPath;
  }

  if (hasWorkspace && platformRole !== "platform_admin") {
    return getWorkspaceLandingPath(user, "/");
  }

  const roleHomePath = getRoleHomePath(role, platformRole);
  if (isAuthPagePath(roleHomePath)) {
    return ROLE_HOME_PATHS.customer;
  }

  return roleHomePath;
};
